module.exports = __webpack_public_path__ + "img/20.57902de9.png";